import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var ValuationIcon = function ValuationIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.004 17.327",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: fillColor,
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-width": "".concat((_e = attrs["stroke-width"]) !== null && _e !== void 0 ? _e : "1.3")
  }, [h("path", {
    d: "M16.105 5.256 9.168.908a1.488 1.488 0 0 0-1.583 0l-6.233 3.91a1.487 1.487 0 0 0-.7 1.265v9.1a1.49 1.49 0 0 0 1.49 1.49h6.235"
  }), h("path", {
    d: "M16.112 13.732a3.765 3.765 0 0 1-1.6 1.478 3.916 3.916 0 0 1-5.514-3.779v.152a3.916 3.916 0 0 1 5.514-3.779 3.771 3.771 0 0 1 1.6 1.478"
  }), h("path", {
    d: "M7.248 10.386h5.406"
  }), h("path", {
    d: "M7.248 12.927h5.406"
  })]));
};